import { UnitWorkloadDetails } from '#server/models';

interface UnitWorkloadHeaderProps {
  unitWorkloadDetails: UnitWorkloadDetails;
}
export const UnitWorkloadHeader = ({ unitWorkloadDetails }: UnitWorkloadHeaderProps) => {
  return (
    <div className="flex h-32 flex-shrink-0 items-center justify-start gap-20 self-stretch px-8">
      <div className="pr-2">
        <h1 className="pb-[3px] text-[28px] font-bold leading-[36px]">{unitWorkloadDetails?.unit?.name}</h1>
        <p className="text-[20px] font-semibold leading-[30px] text-primary-black-90">
          {unitWorkloadDetails?.unit?.udc}
        </p>
      </div>
      <div>
        <p className="mt-2 text-[18px] font-normal leading-[28px] text-secondary-grey-02">Manage unit allocations</p>
        <p className="mt-1 text-[20px] font-semibold leading-[30px]">
          {' '}
          {unitWorkloadDetails?.studyPeriod?.name} {unitWorkloadDetails && ','} {unitWorkloadDetails?.studyPeriod?.year}
        </p>
      </div>
    </div>
  );
};
